/*
 * Presentación del incremento 20/21 · Préstamos: alta y pagos.
 *
 * REGLA DURA DE TODO EL MÓDULO (RNF-038, RNF-138): aquí no se arma ningún contador,
 * no se divide ningún importe, no se reparte capital e interés y no se calcula
 * ninguna fecha. El «15/48», el «14/48», el reparto propuesto, el pago esperado del
 * periodo, su etiqueta y el calendario completo viajan YA RESUELTOS del servidor.
 * Una interpolación que arme un contador o un `AddMonths` disfrazado en este módulo
 * es defecto de construcción, aunque dé bien el resultado.
 *
 * LOS DOS CONTADORES NO SE CONFUNDEN NUNCA (RN-779, D-458):
 *   · AVANCE DEL PLAN — cuántos pagos YA CARGÓ el calendario. Es `contadorDeAvance`
 *     y se enseña en el detalle: 14/48 con el pago 15 registrado y su fecha por
 *     llegar.
 *   · IDENTIDAD DE UNA MENSUALIDAD — el `contadorDeMensualidad` de un pago concreto.
 *     Es el del renglón de lo que vence, el del encabezado del pago y el del
 *     renglón del calendario: 15/48 en octubre, el mismo valor antes y después de
 *     registrar el pago.
 */

export { formatearImporte as importe } from '../../nucleo/importes/formatoDeImporte.js';

/** Mismo umbral del pliegue por año que fijó el incremento 22 (RN-767, RN-776). */
export { UMBRAL_DE_PLIEGUE_POR_ANIO } from '../msi/formato.js';

/** El plazo, con los topes de la maquinaria única (RN-759, D-454). */
export { MESES_MAXIMO as PAGOS_MAXIMO, MESES_MINIMO as PAGOS_MINIMO } from '../msi/formato.js';

/**
 * Los cuatro estados del periodo del préstamo (D-438, RN-749). El NOMBRE VISIBLE
 * viaja del servidor (`textoEtiquetaDelPeriodo`, RNF-130); esto solo resuelve el
 * aspecto de la insignia, que es presentación.
 */
export const ASPECTO_DE_LA_ETIQUETA = {
  PAGADA: 'ok',
  PARCIAL: 'w',
  VENCIDA: 'e',
  POR_VENCER: '',
};

/**
 * Nombre visible de cada estado de un pago del calendario. La CLAVE es el valor
 * estable para la lógica; el nombre nunca se compara.
 *
 * «Cargada» es la palabra del banco en una tarjeta; en un préstamo la titular paga,
 * así que el renglón dice «pagado» (RN-776, prototipo v46 `-prestamo-detalle`).
 */
export const NOMBRE_DEL_ESTADO_DE_PAGO = {
  PENDIENTE: 'Por pagar',
  CARGADA: 'Pagado',
  LIQUIDADA: 'Pagado',
  CANCELADA: 'Cancelado',
};

/**
 * RN-776 · el sustantivo del renglón de año en el calendario plegado del préstamo.
 * La pieza del 22 es la misma; solo cambia la palabra, porque un préstamo lleva
 * PAGOS y no mensualidades de una compra.
 */
export const SUSTANTIVO_DEL_PRESTAMO = { singular: 'pago', plural: 'pagos' };

/**
 * RN-776 · el estado agregado del año, con las palabras del préstamo. Los tres
 * casos son los mismos que fijó RN-767 y no hay un cuarto.
 */
export function resumirElAnioDelPrestamo(grupo) {
  if (grupo.todasCargadas) return 'Todos pagados';
  if (grupo.todasPorCaer) return 'Todos por pagar';
  return `${grupo.cargadas} pagados · ${grupo.porCaer} por pagar`;
}
